import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { Account } from '../../../../model/account.model';
import { IMoney } from '../../../../model/money.model';
import { Observable, Subject } from 'rxjs';
import { IServiceItem } from '../../../../model/service-item.model';
import { ICountry } from '../../../../model/country.model';
import { CostsRuleColumnName, ICostsRuleColumnName } from '../../fees/fees-column-name';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CostsRuleValidator } from '../../fees/fees-validator';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { MoniesService } from '../../monies/monies.service';
import { CostsRuleService } from '../../fees/costs-rule.service';
import { CountryService } from '../../countries/countries.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ServiceItemService } from '../../service-items/service-item.service';
import { FormService } from '../../../../shared/services/form.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { TIME_MIN_REQUEST, TIME_MIN_X1_REQUEST } from '../../../../shared/constant/request.contant';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { CostsRule, ICostsRule } from '../../../../model/costs-rule.model';
import { ExchangeRateService } from '../exchange-rate.service';
import { ExchangeColumnName, IExchangeColumnName } from '../exchange-rate-column-name';
import { ExchangeRate, IExchangeRate } from '../../../../model/exchange-rate.model';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import { IVExchangeColumnName, VExchangeColumnName } from '../../version-exch-rate/vexchange-rate-column-name';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { IVersionExchangeRate } from '../../../../model/version-exchange-rate.model';
import { VersionExchangeRateService } from '../../version-exch-rate/version-exchange-rate.service';

/**
 * Permet de gérer l'ajout des exchange rate.
 */
@Component({
  selector: 'app-exchange-rate-add',
  templateUrl: './exchange-rate-add.component.html',
  animations: [fadeIn]
})
export class ExchangeRateAddComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  account: Account; // The account connected.

  findVersionList = false;

  column: IExchangeColumnName;
  private subs$ = new Subject<void>();

  filteredOptions: Observable<IVersionExchangeRate[]>;
  versionExchangeRateList: IVersionExchangeRate[] = [];

  isSaving = false;
  successSave = false;
  serverHasError = false;
  editForm: UntypedFormGroup;

  theDialogRef: MatDialogRef<ExchangeRateAddComponent>;

  constructor(
    protected versionExchangeRateService: VersionExchangeRateService,
    private accountService: AccountService,
    protected exchangeRateService: ExchangeRateService,
    private dialogRef: MatDialogRef<ExchangeRateAddComponent>,
    private formService: FormService,
    private columnName: ExchangeColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct exchange rate add');
    this.theDialogRef = this.dialogRef;
    this.column = this.columnName.getColumnName();
    this.initForm(fb);
  }

  ngOnInit(): void {
    console.log('## init exchange rate add');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
      this.account = account;
      this.getVersionExchangeRateList();
    });
  }

  ngOnDestroy() {
    console.log('## destroy exchange rate add');
    this.formService.free(this.subs$);
    this.successSave = false;
  }

  displayFnVersion(subject: IVersionExchangeRate) {
    return subject ? subject.version : '';
  }

  initForm(fb: UntypedFormBuilder) {
    try {
      this.editForm = this.fb.group({
        id: [],
        sourceMoney: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(5),
            Validators.pattern('^[A-Za-z]+((\\s)?([A-Za-z])+)*$')]
        ],
        destMoney: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(5),
            Validators.pattern('^[A-Za-z]+((\\s)?([A-Za-z])+)*$')]
        ],
        resultExchange: ['', [Validators.required, Validators.minLength(1),
          Validators.maxLength(50), Validators.pattern('^[0-9]+(\\.[0-9]*){0,1}$')]],
        versionExchangeRateId: ['', [Validators.required]]
      });

    } catch (e) {
      console.log('## error form: ' + e.message);
    }
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  hasFound(): boolean {
    return this.findVersionList;
  }

  /**
   * Récupère la liste des versions d'exchange rate et
   * les initialise dans un auto complete
   */
  getVersionExchangeRateList() {
    this.findVersionList = false;
    setTimeout(() => {
      this.versionExchangeRateService
        .query()
        .pipe(
          filter((mayBeOk: HttpResponse<IVersionExchangeRate[]>) => mayBeOk.ok),
          map((response: HttpResponse<IVersionExchangeRate[]>) => response.body)
        )
        .subscribe((res: IVersionExchangeRate[]) => {
            console.log('## success get list version of exchange rate while adding: ', res);
            const rs = res ? res : [];
            console.log('## size: ' + rs.length);
            this.versionExchangeRateList = rs;
            this.findVersionList = true;
            this.filteredOptions = this.editForm.get(this.column.versionExchangeRateId).valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value))
              );
          },
          (res: HttpErrorResponse) => {
            console.log('## error get list version of exchange rate while adding: ' + res.message);
          });
    }, TIME_MIN_X1_REQUEST);
  }

  private _filter(value: any): IVersionExchangeRate[] {
    let filteredList;
    try {
      console.log('## value version ', value);
      const filterValue = (typeof value === 'string') ? value.toLowerCase() : value.version.toLowerCase();
      filteredList = this.versionExchangeRateList.filter(option => option.version.toLowerCase()
        .includes(filterValue));
    } catch (e) {
      console.log('## error filter version of exchange rate: ' + e.message);
    }
    return filteredList;
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## save exchange rate');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c: IExchangeRate = this.createFromForm();
    console.log('## data: ', c);
    this.exchangeRateService.create(c).subscribe(res => {
        console.log('## success create exchange rate');
        this.serverHasError = false;
        this.responseFromServer();
        this.editForm.reset();
        this.getVersionExchangeRateList();
        this.successSave = true;
        this.exchangeRateService.getAllExchangeRateByVersion(this.exchangeRateService
          .versionExchangeRateSelected.id);
      },
      err => {
        console.log('## error create exchange rate: ', err);
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
      });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, TIME_MIN_REQUEST);
  }

  private createFromForm(): IExchangeRate {
    return {
      ...new ExchangeRate(),
      id: this.editForm.get([this.column.id]).value,
      destMoney: this.editForm.get([this.column.destMoney]).value,
      sourceMoney: this.editForm.get([this.column.sourceMoney]).value,
      resultExchange: this.editForm.get([this.column.resultExchange]).value,
      versionExchangeRateId: this.editForm.get([this.column.versionExchangeRateId]).value.id,
    };
  }

  closeModal() {
    console.log('## close exchange rate add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }
  reset(){
    this.editForm.reset();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.editForm);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.editForm, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.editForm,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.editForm, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.editForm, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.editForm, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.editForm, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.editForm, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.editForm, column);
  }

}
